<script lang="ts" setup>
	import {computed} from 'vue';

	const contactPageUrl = computed(() => window.contactPageBaseUrl + '#offices');
</script>

<template>
	<VDropdown distance="20"
	           placement="right">
		<span class="js-tooltip">
			<svg class="icon-phone" height="11" width="11">
				<use xlink:href="/assets/images/build/svg-sprite.catalog.min.svg#phone"></use>
			</svg>
		</span>

		<template #popper>
			<div class="tooltip">
				<span>
					<a :href="contactPageUrl">
						{{ $t('site.products.overview.availability.unknown.text') }}
					</a>
				</span>
			</div>
		</template>
	</VDropdown>
</template>


<style lang="scss" scoped>
	.tooltip {
		line-height: 18px;
		padding: 6px 14px;
	}

	.tooltip span a {
		text-decoration: none;
	}
</style>
